import { ReactElement, useEffect } from 'react';
import { useUINav } from '@/ui';
import { useCompanyContext, useTeam } from '@/companies/providers';
import { TeamNotificationsSettingsSection } from '@/companies/components';
import { usePagesTranslation } from '../../hooks';

export function TeamIdNotificationsSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { company } = useCompanyContext();
    const { team } = useTeam();

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            {
                text: t('shared.labels.teams'),
                link: `/company/${company.id}/settings/teams`
            },
            { text: team.name },
            { text: t('shared.labels.notifications') }
        ]);
    }, [setParts, company.id, team.name, t]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <TeamNotificationsSettingsSection team={team} />
        </div>
    );
}
